// extracted by mini-css-extract-plugin
export default {"hideDefaultIcons":"LabeledTimeInput_hideDefaultIcons__5YMJC","disabled":"LabeledTimeInput_disabled__1nShT"};